<template lang="pug">
  .relative.h-full
    .-my-2.h-12.w-12.rounded-full.text-white.flex.items-center.justify-center(:class="statusClass")
      b.text-5xl
        sw-icon(v-if="success || error" :name="icon")
        .h-5.w-5.bg-white.rounded-full(v-else)
    .flex.flex-no-wrap
      sw-speech-balloon(v-if="content" imagePath='shared/hugues.jpg')
        span(v-html="content")
</template>

<script>
import SwSpeechBalloon from './SwSpeechBalloon';
export default {
  name: 'SwGuide',
  components: {
    SwSpeechBalloon,
  },
  props: {
    content: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: true,
    },
    status: {
      type: String,
      default: 'ongoing',
    },
  },
  computed: {
    statusClass () {
      return this.error ? 'bg-red-500' : 'bg-blue-500';
    },
    success () {
      return this.status === 'success';
    },
    error () {
      return this.status === 'error';
    },
    icon () {
      return this.error ? 'close' : 'check';
    },
  },
};
</script>
